export default __webpack_public_path__ + "static/media/7789-Joint&Muscle-Support.3ad395d8.jpg";